import { createContext, useContext, useState, useEffect } from "react";

const GeneralContext = createContext();

export default function GeneralProvider({ children }) {
  const [userInformation, setUserInformation] = useState(getUserInfo());

  function getUserInfo() {
    let user = localStorage.getItem("@vitae/user");
    if (user) {
      return JSON.parse(user);
    } else {
      return {};
    }
  }
  useEffect(() => {
    document.getElementById(
      "current_company_id"
    ).value = getUserInfo().companyAbbreviation;
  }, []);

  function hasPermission(permission) {
    return userInformation?.permission?.indexOf(permission) > -1;
  }

  return (
    <GeneralContext.Provider
      value={{
        userInformation,
        setUserInformation,
        hasPermission,
        getUserInfo
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
}

export function useGeneralContext() {
  return useContext(GeneralContext);
}
